import * as Common from '@/agiles/common';


export class ProductTour extends Common.StateObject{
    constructor(){
        super('ProductTour');        
        this.workflowCode="approval";
        this.workflowStateId = 1;//フラグ値を変更;        
    }    
        public id: number;
        public displayOrder: number;
        public title: string;
        public path: string;
        public tourId:number;
}

export class ProductTourQuery extends Common.LoadQuery {
  constructor() {
    super('ProductTourQuery', ProductTour);
    this.sort = 'displayOrder';
  }
}
